import { Dealer } from "../../account/models/dealer.model";
import { RatingsSummary } from "../../account/models/ratings-summary";
import { BuyAction } from "../../buy/constants/buy-basic-data";
import { Proposal } from "../../buy/models/proposal.model";
import { Appointment } from "../../common/models/appointment.model";
import { Conversation } from "../../common/models/conversation.model";
import { Price, Offer } from "../../common/models/string-data.model";
import { Job } from "../../keep/models/job.model";
import { Posting } from "../../keep/models/posting.model";
import { Booking } from "../../rent/models/booking.model";
import { CarStatus, CarBusinessLine } from "../constants/car-basic-data";


export class Car {
  carId = '';
  offerId = '';
  favorite = false;
  customer = false;
  provider = false;
  providerActive = false;
  acceptIntermediation = false;
  businessLine: CarBusinessLine = CarBusinessLine.BUY
  
  ownerId = '';
  owner: Dealer = new Dealer();

  ownerName = '';
  ownerType = '';
  ownerCountry = '';
  ownerPhone = 0;
  ownerAddress= '';
  ownerBusinessName= '';
  ownerRatingsSummary: RatingsSummary = new RatingsSummary();

  providerId = '';
  //provider: Dealer = new Dealer();

  providerName = '';
  providerType = '';
  providerCountry = '';
  providerPhone = 0;
  providerAddress= '';
  providerBusinessName= '';
  providerRatingsSummary: RatingsSummary = new RatingsSummary();

  chassis = '';

  makeId = 0;
  modelId = 0;
  //versionId = 0;
  engineId = 0;

  make = '';
  model = '';
  version = '';
  engine = '';

  features: string[] = [];

  year = 0;
  bodyType = '';
  condition = '';
  mileage = 0;

  doors = 0;
  seats = 0;

  countryOrigin = '';
  country = '';
  city = '';

  serviceHistory = '';

  fuel = '';
  powerHp = 0;
  powerKw = 0;
  gearBox = '';

  exteriorColor = '';
  exteriorColorMetallic = '';
  interiorColor = '';
  interiorMaterial = '';

  optionalEquipment = '';
  extraEquipment = '';

  status: CarStatus = CarStatus.DRAFT;
  image: any;

  arrivalDate = '';
  arrivalLocation = '';
  description = '';

  created = '';
  lastUpdated = '';

  imagesFilenames: string[] = [];
  documentsFilenames: string[] = [];

  buyPrice: Price = Price.getDefault();
  rentDayRate: Price = Price.getDefault();
  rentInsuranceDayRate: Price = Price.getDefault();
  rentDriverDayRate: Price = Price.getDefault();
  keepPrice: Price = Price.getDefault();

  buyPriceHistory: Price [] = [];
  rentDayRateHistory: Price [] = [];
  rentInsuranceDayRateHistory: Price [] = [];
  rentDriverDayRateHistory: Price [] = [];
  keepPriceHistory: Price [] = [];

  buyActive: boolean = false;
  rentActive: boolean = false;

  selectedBusinessLine: CarBusinessLine = CarBusinessLine.BUY;

  offerTitle = "";
  offerDescription = "";

  offerPosted = false;
  offerClosed = false;

  offerStartDate = "";
  offerEndDate = "";

  postings: Posting[] = [];
  offers: Offer[] = [];
  appointments: Appointment[] = [];
  proposals: Proposal[] = [];
  myBookings: Booking[] = [];
  allBookings: Booking[] = [];
  conversations: Conversation[] = [];
  jobs: Job[] = [];

  buyOffers: Car[] = [];
  rentOffers: Car[] = [];

  actions: BuyAction[] = [];

  constructor (mk?: string)  {
    this.make = mk!;
    this.offers = [];

    this.buyPriceHistory = [];
    this.rentDayRateHistory = [];
    this.rentInsuranceDayRateHistory = [];
    this.rentDriverDayRateHistory = [];
    this.keepPriceHistory = [];

    this.appointments = [];
    this.proposals = [];
    this.myBookings = [];
    this.allBookings = [];
    this.conversations = [];
    this.jobs = [];

    this.buyOffers = [];
    this.rentOffers = [];

    this.imagesFilenames = [];
    this.documentsFilenames = [];

    this.actions = []
  }

   
  public getCarPrice(businessLine: CarBusinessLine): Price{

    switch(businessLine.toString()){

      case CarBusinessLine.BUY.toString(): {
        return this.buyPrice;
      }

      case CarBusinessLine.RENT.toString(): {
        return this.rentDayRate;
      }

      default: {
        return Price.getDefault();
      }
    }
  }
}